import type { SVGProps } from "react";
export interface LemonIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LemonIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LemonIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.515 4.515C7.688 1.342 12.117.19 15.942 1.27l.321.076q.468.088.85.012l.924-.185.252-.042a4.07 4.07 0 0 1 3.426 1.156l.175.184c.782.886 1.14 2.07.981 3.242l-.042.25-.185.925q-.101.508.086 1.17l.096.36c.91 3.741-.268 7.993-3.342 11.067s-7.326 4.253-11.067 3.342l-.36-.096a2.8 2.8 0 0 0-.907-.12l-.263.034-.925.185a4.07 4.07 0 0 1-3.492-.94l-.184-.174a4.07 4.07 0 0 1-1.114-3.678l.185-.924.032-.264a2.8 2.8 0 0 0-.12-.907c-1.08-3.825.073-8.254 3.246-11.427Zm10.817-1.08c-2.992-.844-6.591.036-9.226 2.67-2.635 2.636-3.515 6.235-2.67 9.226.188.667.284 1.434.127 2.223l-.185.925a1.822 1.822 0 0 0 2.143 2.143l.925-.186c.788-.157 1.556-.059 2.222.13l.568.137c2.87.59 6.187-.34 8.657-2.81s3.4-5.787 2.81-8.657l-.138-.568c-.188-.666-.286-1.434-.129-2.222l.186-.925.03-.225a1.82 1.82 0 0 0-1.948-1.948l-.225.03-.925.185c-.69.138-1.364.08-1.968-.062l-.255-.065Z"
      />
      <path
        fill={color}
        d="M15.375 17a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141A1.375 1.375 0 0 1 14 15.625l.14.007c.694.07 1.235.656 1.235 1.368m-4 0a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 10 15.625l.141.007c.693.07 1.233.657 1.233 1.368Zm2-3a1.375 1.375 0 0 1-2.743.141l-.008-.14.008-.141a1.375 1.375 0 0 1 2.743.14"
      />
    </svg>
  );
}
